"use strict"; // SCRAPE
// https://www.dhs.gov/immigration-statistics/lawful-permanent-residents/ImmigrantCOA
// WITH THIS IN CONSOLE
// Array.from(document.querySelectorAll('tr')).reduce((obj, tr) => {
//   if (tr.querySelector('th')?.innerText) {
//       obj[tr.querySelector('th')?.innerText] = tr.querySelector('td')?.innerText;
//   }
//   return obj;
// }, {})

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMMIGRATION_CLASSES_OF_ADMISSION = void 0; //NOTE: Currently not used, may need to re-introduce once we handle more than just asylum work permits

exports.IMMIGRATION_CLASSES_OF_ADMISSION = {
  A11: "Unmarried Amerasian sons/daughters of U.S. citizens, new arrivals",
  A12: "Children of A11 or A16, new arrivals",
  A16: "Unmarried Amerasian sons/daughters of U.S. citizens, adjustments",
  A17: "Children of A11 or A16, adjustments",
  A31: "Married Amerasian sons/daughters of U.S. citizens, new arrivals",
  A32: "Spouses of A31 or A36, new arrivals",
  A33: "Children of A31 or A36, subject to country limits, new arrivals",
  A36: "Married Amerasian sons/daughters of U.S. citizens, adjustments",
  A37: "Spouses of A31 or A36, adjustments",
  A38: "Children of A31 or A36, subject to country limits, adjustments",
  AA1: "Natives of certain adversely affected foreign states, new arrivals",
  AA2: "Spouses of AA1 or AA6, new arrivals",
  AA3: "Children of AA1 or AA6, new arrivals",
  AA6: "Natives of certain adversely affected foreign states, adjustments",
  AA7: "Spouses of AA1 or AA6, adjustments",
  AA8: "Children of AA1 or AA6, adjustments",
  AM1: "Amerasians, born in Vietnam between 1/1/62-1/1/76, new arrivals",
  AM2: "Spouses or children of AM1 or AM6, new arrivals",
  AM3: "Mothers, guardians, or next of kin of AM1 or AM6, new arrivals",
  AM6: "Amerasians, born in Vietnam between 1/1/62-1/1/76, adjustments",
  AM7: "Spouses or children of AM1 or AM6, adjustments",
  AM8: "Mothers, guardians, or next of kin of AM1 or AM6, adjustments",
  AR1: "Children, Amerasian, new arrivals",
  AR6: "Children, Amerasian, adjustments",
  AS6: "Asylees",
  AS7: "Spouses of AS6",
  AS8: "Children of AS6",
  B11: "Unmarried sons/daughters of U.S. citizens, new arrivals, self petitioning",
  B12: "Children of B11 or B16, new arrivals",
  B16: "Unmarried sons/daughters of U.S. citizens, adjustments, self petitioning",
  B17: "Children of B11 or B16, adjustments",
  B20: "Children of B24 or B29, subject to country limits, adjustments",
  B21: "Spouses of alien residents, subject to country limits, new arrivals, self petitioning",
  B22: "Children of alien residents, subject to country limits, new arrivals, self petitioning",
  B23: "Children of B21, B22, B26, or B27, subject to country limits, new arrivals",
  B24: "Unmarried sons/daughters of alien residents, subject to country limits, new arrivals, self petitioning",
  B25: "Children of B24 or B29, subject to country limits, new arrivals",
  B26: "Spouses of alien residents, subject to country limits, adjustments, self petitioning",
  B27: "Children of alien residents, subject to country limits, adjustments, self petitioning",
  B28: "Children of B21, B22, B26, or B27, subject to country limits, adjustments",
  B29: "Unmarried sons/daughters of alien residents, subject to country limits, adjustments, self petitioning",
  B31: "Married sons/daughters of U.S. citizens, new arrivals, self petitioning",
  B32: "Spouses of B31 or B36, new arrivals",
  B33: "Children of B31 or B36, subject to country limits, new arrivals",
  B36: "Married sons/daughters of U.S. citizens, adjustments, self petitioning",
  B37: "Spouses of B31 or B36, adjustments",
  B38: "Children of B31 or B36, subject to country limits, adjustments",
  BC1: "Broadcast (IBCB of BBG) employees, new arrivals",
  BC2: "Spouses of BC1 or BC6, new arrivals",
  BC3: "Children of BC1 or BC6, new arrivals",
  BC6: "Broadcast (IBCG of BBG) employees, adjustments",
  BC7: "Spouses of BC1 or BC6, adjustments",
  BC8: "Children of BC1 or BC6, adjustments",
  BX1: "Spouses of alien residents, exempt from country limits, new arrivals, self petitioning",
  BX2: "Children of alien residents, exempt from country limits, new arrivals, self petitioning",
  BX3: "Children of BX1, BX2, BX6, or BX7, exempt from country limits, new arrivals",
  BX6: "Spouses of alien residents, exempt from country limits, adjustments, self petitioning",
  BX7: "Children of alien residents, exempt from country limits, adjustments, self petitioning",
  BX8: "Children of BX1, BX2, BX6, or BX7, exempt from country limits, adjustments",
  C20: "Children of C24 or C29, subject to country limits, adjustments, conditional",
  C21: "Spouses of alien residents, subject to country limits, new arrivals, conditional",
  C22: "Children of alien residents, subject to country limits, new arrivals, conditional",
  C23: "Children of C21, C22, C26, or C27, subject to country limits, new arrivals, conditional",
  C24: "Unmarried children of alien residents, subject to country limits, new arrivals, conditional",
  C25: "Children of C24 or C29, subject to country limits, new arrivals, conditional",
  C26: "Spouses of alien residents, subject to country limits, adjustments, conditional",
  C27: "Children of alien residents, subject to country limits, adjustments, conditional",
  C28: "Children of C21, C22, C26, or C27, subject to country limits, adjustments, conditional",
  C29: "Unmarried children of alien residents, subject to country limits, adjustments, conditional",
  C31: "Married sons/daughters of U.S. citizens, new arrivals, conditional",
  C32: "Spouses of C31 or C36, new arrivals, conditional",
  C33: "Children of C31 or C36, subject to country limits, new arrivals, conditional",
  C36: "Married sons/daughters of U.S. citizens, adjustments, conditional",
  C37: "Spouses of married sons/daughters of U.S. citizens, adjustments, conditional",
  C38: "Children of C31 or C36, subject to country limits, adjustments, conditional",
  C51: "Employment creation, not in targeted area, new arrivals, conditional",
  C52: "Spouses of C51 or C56, new arrivals, conditional",
  C53: "Children of C51 or C56, new arrivals, conditional",
  C56: "Employment creation, not in targeted area, adjustments, conditional",
  C57: "Spouses of C51 or C56, adjustments, conditional",
  C58: "Children of C51 or C56, adjustments, conditional",
  CB1: "Spouses of legalized aliens, new arrivals, conditional",
  CB2: "Children of CB1 or CB6, new arrivals, conditional",
  CB6: "Spouses of legalized aliens, adjustments, conditional",
  CB7: "Children of CB1 or CB6, adjustments, conditional",
  CF1: "Spouses, entered as fiance(e), adjustments, conditional",
  CF2: "Children of CF1, adjustments, conditional",
  CH6: "Cuban Haitian entrants, adjustments (P.L. 99-603)",
  CR1: "Spouses, new arrivals, conditional",
  CR2: "Children, new arrivals, conditional",
  CR6: "Spouses, adjustments, conditional",
  CR7: "Children, adjustments, conditional",
  CU6: "Cuban refugees (P.L. 89-732 of 1966)",
  CU7: "Non-Cuban spouses or children of Cuban refugees",
  CX1: "Spouses of alien residents, exempt from country limits, new arrivals, conditional",
  CX2: "Children of alien residents, exempt from country limits, new arrivals, conditional",
  CX3: "Children of CX2 or CX7, exempt from country limits, new arrivals, conditional",
  CX6: "Spouses of alien residents, exempt from country limits, adjustments, conditional",
  CX7: "Children of alien residents, exempt from country limits, adjustments, conditional",
  CX8: "Children of CX2 or CX7, exempt from country limits, adjustments, conditional",
  DS1: "Individuals born under diplomatic status, adjustments,",
  DT1: "Natives of Tibet who continuously resided in Nepal or India (Displaced Tibetan), new arrivals",
  DT2: "Spouses of DT1 or DT6, new arrivals",
  DT3: "Children of DT1 or DT6, new arrivals",
  DT6: "Natives of Tibet who continuously resided in Nepal or India (Displaced Tibetan), adjustments",
  DT7: "Spouses of DT1 or DT6, adjustments",
  DT8: "Children of DT1 or DT6, adjustments",
  DV1: "Principals, new arrivals",
  DV2: "Spouses of DV1 or DV6, new arrivals",
  DV3: "Children of DV1 or DV6, new arrivals",
  DV6: "Principals, adjustments",
  DV7: "Spouses of DV1 or DV6, adjustments",
  DV8: "Children of DV1 or DV6, adjustments",
  E10: "Children of E11, E12, E13, E16, E17, or E18, adjustments",
  E11: "Aliens with extraordinary ability, new arrivals",
  E12: "Outstanding professors or researchers, new arrivals",
  E13: "Multinational executives or managers, new arrivals",
  E14: "Spouses of E11, E12, E13, E16, E17, or E18, new arrivals",
  E15: "Children of E11, E12, E13, E16, E17, or E18, new arrivals",
  E16: "Aliens with extraordinary ability, adjustments",
  E17: "Outstanding professors or researchers, adjustments",
  E18: "Multinational executives or managers, adjustments",
  E19: "Spouses of E11, E12, E13, E16, E17, or E18, adjustments",
  E21: "Professionals holding advanced degrees, new arrivals",
  E22: "Spouses of E21 or E26, new arrivals",
  E23: "Children of E21 or E26, new arrivals",
  E26: "Professionals holding advanced degrees, adjustments",
  E27: "Spouses of E21 or E26, adjustments",
  E28: "Children of E21 or E26, adjustments",
  E30: "Children of E31, E32, E36, or E37, adjustments",
  E31: "Skilled workers, new arrivals",
  E32: "Professionals with baccalaureate degrees, new arrivals",
  E34: "Spouses of E31, E32, E36, or E37, new arrivals",
  E35: "Children of E31, E32, E36, or E37, new arrivals",
  E36: "Skilled workers, adjustments",
  E37: "Professionals with baccalaureate degrees, adjustments",
  E39: "Spouses of E31, E32, E36, or E37, adjustments",
  E51: "Employment creation, new arrivals",
  E52: "Spouses of E51 or E56, new arrivals",
  E53: "Children of E51 or E56, new arrivals",
  E56: "Employment creation, adjustments",
  E57: "Spouses of E51 or E56, adjustments",
  E58: "Children of E51 or E56, adjustments",
  EC6: "Chinese Student Protection Act (CSPA) principals, adjustments",
  EC7: "Spouses of EC6, adjustments",
  EC8: "Children of EC6, adjustments",
  ES1: "Soviet scientists, new arrivals",
  ES6: "Soviet scientists, adjustments",
  EW0: "Children of EW3 or EW8, adjustments",
  EW3: "Needed unskilled workers, new arrivals",
  EW4: "Spouses of EW3 or EW8, new arrivals",
  EW5: "Children of EW3 or EW8, new arrivals",
  EW8: "Needed unskilled workers, adjustments",
  EW9: "Spouses of EW3 or EW8, adjustments",
  EX1: "Schedule - A worker, new arrivals",
  EX2: "Spouses of EX1 or EX6, new arrivals",
  EX3: "Children of EX1 or EX6, new arrivals",
  EX6: "Schedule - A worker, adjustments",
  EX7: "Spouses of EX1 or EX6, adjustments",
  EX8: "Children of EX1 or EX6, adjustments",
  F11: "Unmarried sons/daughters of U.S. citizens, new arrivals",
  F12: "Children of F11 or F16, new arrivals",
  F16: "Unmarried sons/daughters of U.S. citizens, adjustments",
  F17: "Children of F11 or F16, adjustments",
  F20: "Children of F24 or F29, subject to country limits, adjustments",
  F21: "Spouses of alien residents, subject to country limits, new arrivals",
  F22: "Children of alien residents, subject to country limits, new arrivals",
  F23: "Children of F21, F22, F26, or F27, subject to country limits, new arrivals",
  F24: "Unmarried sons/daughters of alien residents, subject to country limits, new arrivals",
  F25: "Children of F24 or F29, subject to country limits, new arrivals",
  F26: "Spouses of alien residents, subject to country limits, adjustments",
  F27: "Children of alien residents, subject to country limits, adjustments",
  F28: "Children of F21, F22, F26, or F27, subject to country limits, adjustments",
  F29: "Unmarried sons/daughters of alien residents, subject to country limits, adjustments",
  F31: "Married sons/daughters of U.S. citizens, new arrivals",
  F32: "Spouses of married sons/daughters of U.S. citizens, new arrivals",
  F33: "Children of married sons/daughters of U.S. citizens, new arrivals",
  F36: "Married sons/daughters of U.S. citizens, adjustments",
  F37: "Spouses of married sons/daughters of U.S. citizens, adjustments",
  F38: "Children of married sons/daughters of U.S. citizens, adjustments",
  F41: "Brothers/sisters of U.S. citizens, new arrivals",
  F42: "Spouses of brothers/sisters of U.S. citizens, new arrivals",
  F43: "Children of brothers/sisters of U.S. citizens, new arrivals",
  F46: "Brothers/sisters of U.S. citizens, adjustments",
  F47: "Spouses of brothers/sisters of U.S. citizens, adjustments",
  F48: "Children of brothers/sisters of U.S. citizens, adjustments",
  FX1: "Spouses of alien residents, exempt from country limits, new arrivals",
  FX2: "Children of alien residents, exempt from country limits, new arrivals",
  FX3: "Children of FX1, FX2, FX7, or FX8, exempt from country limits, new arrivals",
  FX6: "Spouses of alien residents, exempt from country limits, adjustments",
  FX7: "Children of alien residents, exempt from country limits, adjustments",
  FX8: "Children of FX1, FX2, FX7, or FX8, exempt from country limits, adjustments",
  GA6: "Iraqi asylees",
  GA7: "Spouses of GA6",
  GA8: "Children of GA6",
  HA6: "Haitian asylum applicants",
  HA7: "Spouses of HA6",
  HA8: "Children of HA6",
  HA9: "Unmarried sons/daughters of HA6",
  HB6: "Haitian parolees",
  HB7: "Spouses of HB6",
  HB8: "Children of HB6",
  HB9: "Unmarried sons/daughters of HB6",
  HC6: "Haitian children without parents",
  HC7: "Spouses of HC6",
  HC8: "Children of HC6",
  HC9: "Unmarried sons/daughters of HC6",
  HD6: "Haitian children orphaned in the United States",
  HD7: "Spouses of HD6",
  HD8: "Children of HD6",
  HD9: "Unmarried sons/daughters of HD6",
  HE6: "Haitian children abandoned by parents",
  HE7: "Spouses of HE6",
  HE8: "Children of HE6",
  HE9: "Unmarried sons/daughters of HE6",
  HH6: "Parolees adjusting under the Help HAITI Act of 2010, adjustments",
  HK1: "Hong Kong business employees, new arrivals",
  HK2: "Spouses of HK1 or HK6, new arrivals",
  HK3: "Children of HK1 or HK6, new arrivals",
  HK6: "Hong Kong business employees, adjustments",
  HK7: "Spouses of HK1 or HK6, adjustments",
  HK8: "Children of HK1 or HK6, adjustments",
  I51: "Employment creation, targeted area, pilot program, new arrivals, conditional",
  I52: "Spouses of I51 or I56, new arrivals, conditional",
  I53: "Children of I51 or I56, new arrivals, conditional",
  I56: "Employment creation, targeted area, pilot program, adjustments, conditional",
  I57: "Spouses of I51 or I56, adjustments, conditional",
  I58: "Children of I51 or I56, adjustments, conditional",
  IB0: "Parents battered or abused, of U.S. citizens, adjustments, self petitioning",
  IB1: "Spouses, new arrivals, self petitioning",
  IB2: "Children, new arrivals, self petitioning",
  IB3: "Children of IB1 or IB6, new arrivals",
  IB5: "Parents battered or abused, of U.S. citizens, new arrivals, self petitioning",
  IB6: "Spouses, adjustments, self petitioning",
  IB7: "Children, adjustments, self petitioning",
  IB8: "Children of IB1 or IB6, adjustments",
  IC6: "Indochinese refugees (P.L. 95-145 of 1977)",
  IC7: "Spouses or children of Indochinese refugees not qualified as refugees on their own",
  ID6: "Parolees, Indochinese",
  IF1: "Spouses, entered as fiance(e), adjustments",
  IF2: "Children of IF1, adjustments",
  IH3: "Children adopted abroad under the Hague Convention, new arrivals",
  IH4: "Children to be adopted under the Hague Convention, new arrivals",
  IH8: "Children adopted abroad under the Hague Convention, adjustments",
  IH9: "Children to be adopted under the Hague Convention, adjustments",
  IR0: "Parents of adult U.S. citizens, adjustments",
  IR1: "Spouses, new arrivals",
  IR2: "Children, new arrivals",
  IR3: "Orphans adopted abroad, new arrivals",
  IR4: "Orphans to be adopted, new arrivals",
  IR5: "Parents of adult U.S. citizens, new arrivals",
  IR6: "Spouses, adjustments",
  IR7: "Children, adjustments",
  IR8: "Orphans adopted abroad, adjustments",
  IR9: "Orphans to be adopted, adjustments",
  IW1: "Spouses, widows or widowers, new arrivals",
  IW2: "Children of IW1 or IW6, new arrivals",
  IW6: "Spouses, widows or widowers, adjustments",
  IW7: "Children of IW1 or IW6, adjustments",
  LA6: "Parolees, Soviet/Indochinese",
  LB1: "Spouses of legalized aliens, new arrivals",
  LB2: "Children of LB1 or LB6, new arrivals",
  LB6: "Spouses of legalized aliens, adjustments",
  LB7: "Children of LB1 or LB6, adjustments",
  M83: "Refugee escapees previously admitted for lawful permanent resident status, adjustments",
  M93: "Parolees, Hungarian previously admitted for lawful permanent resident status",
  MR0: "Parents of U.S. citizens presumed to be lawful permanent resident aliens - Northern Mariana Islands, adjustments",
  MR6: "Spouses of U.S. citizens presumed to be lawful permanent resident aliens - Northern Mariana Islands, adjustments",
  MR7: "Children of U.S. citizens presumed to be lawful permanent resident aliens - Northern Mariana Islands, adjustments",
  NA3: "Children born abroad to alien residents",
  NC6: "Principals",
  NC7: "Spouses of NC6",
  NC8: "Children of NC6",
  NC9: "Unmarried sons/daughters of NC6",
  NP8: "Alien who filed and was qualified with investor status prior to June 1, 1978",
  NP9: "Spouses or children of NP8, adjustments",
  PH6: "Parolees, Polish/Hungarian",
  R51: "Investor pilot program, not targeted, new arrivals, conditional",
  R52: "Spouses of R51 or R56, new arrivals, conditional",
  R53: "Children of R51 or R56, new arrivals, conditional",
  R56: "Investor pilot program, not targeted, adjustments, conditional",
  R57: "Spouses of R51 or R56, adjustments, conditional",
  R58: "Children of R51 or R56, adjustments, conditional",
  R86: "Refugee parolees (P.L. 95-412 of 1978)",
  RE6: "Other refugees (P.L. 96-212 Refugee Act of 1980)",
  RE7: "Spouses of RE6",
  RE8: "Children of RE6",
  RE9: "Other relatives",
  RN6: "Certain former H1 nonimmigrant registered nurses, adjustments",
  RN7: "Spouses or children of RN6, adjustments",
  S13: "American Indians born in Canada, new arrivals",
  S16: "Seasonal Agricultural Workers (SAW), worked at least 90 days during each year ending May 1, 1984, 1985, and 1986",
  S26: "Seasonal Agricultural Workers (SAW), worked at least 90 days during the year ending on May 1, 1986",
  SC1: "Lost citizenship through marriage, new arrivals",
  SC2: "Lost citizenship through serving in foreign armed forces, new arrivals",
  SC6: "Lost citizenship through marriage, adjustments",
  SC7: "Lost citizenship through serving in foreign armed forces, adjustments",
  SD1: "Ministers, new arrivals",
  SD2: "Spouses of SD1 or SD6, new arrivals",
  SD3: "Children of SD1 or SD6, new arrivals",
  SD6: "Ministers, adjustments",
  SD7: "Spouses of SD1 or SD6, adjustments",
  SD8: "Children of SD1 or SD6, adjustments",
  SE1: "Employees of U.S. government abroad, new arrivals",
  SE2: "Spouses of SE1 or SE6, new arrivals",
  SE3: "Children of SE1 or SE6, new arrivals",
  SE6: "Employees of U.S. government abroad, adjustments",
  SE7: "Spouses of SE1 or SE6, adjustments",
  SE8: "Children of SE1 or SE6, adjustments",
  SF1: "Former employees of the Panama Canal Company or Canal Zone Government, new arrivals",
  SF2: "Spouses or children of SF1 or SF6, new arrivals",
  SF6: "Former employees of the Panama Canal Company or Canal Zone Government, adjustments",
  SF7: "Spouses or children of SF1 or SF6, adjustments",
  SG1: "Former U.S. government employees in the Panama Canal Zone, new arrivals",
  SG2: "Spouses or children of SG1 or SG6, new arrivals",
  SG6: "Former U.S. government employees in the Panama Canal Zone, adjustments",
  SG7: "Spouses or children of SG1 or SG6, adjustments",
  SH1: "Former employees of the Panama Canal Company or Canal Zone government, employed on April 1, 1979, new arrivals",
  SH2: "Spouses or children of SH1 or SH6, new arrivals",
  SH6: "Former employees of the Panama Canal Company or Canal Zone government, employed on April 1, 1979, adjustments",
  SH7: "Spouses or children of SH1 or SH6, adjustments",
  SI1: "Special immigrant interpreters who are nationals of Iraq or Afghanistan, new arrivals",
  SI2: "Spouses of SI1 or SI6, new arrivals",
  SI3: "Children of SI1 or SI6, new arrivals",
  SI6: "Special immigrant interpreters who are nationals of Iraq or Afghanistan, adjustments",
  SI7: "Spouses of SI1 or SI6, adjustments",
  SI8: "Children of SI1 or SI6, adjustments",
  SJ2: "Spouses or children of SJ6, new arrivals",
  SJ6: "Foreign medical school graduate who was licensed to practice in the United States on Jan. 9, 1978, adjustments",
  SJ7: "Spouses or children of SJ6, adjustments",
  SK1: "Retired employees of international organizations, new arrivals",
  SK2: "Spouses of SK1 or SK6, new arrivals",
  SK3: "Certain unmarried children of SK1 or SK6, new arrivals",
  SK4: "Certain surviving spouses of deceased international organization employees, new arrivals",
  SK6: "Retired employees of international organizations, adjustments",
  SK7: "Spouses of SK1 or SK6, adjustments",
  SK8: "Certain unmarried children of SK1 or SK6, adjustments",
  SK9: "Certain surviving spouses of deceased international organization employees, adjustments",
  SL1: "Juvenile court dependents, new arrivals",
  SL6: "Juvenile court dependents, adjustments",
  SM0: "Spouses or children of SM4 or SM9, adjustments",
  SM1: "U.S. Armed Forces personnel, service (12 years) after 10/1/91, new arrivals",
  SM2: "Spouses of SM1 or SM6, new arrivals",
  SM3: "Children of SM1 or SM6, new arrivals",
  SM4: "U.S. Armed Forces personnel, service (12 years) by 10/91, new arrivals",
  SM5: "Spouses or children of SM4 or SM9, new arrivals",
  SM6: "U.S. Armed Forces personnel, service (12 years) after 10/1/91, adjustments",
  SM7: "Spouses of SM1 or SM6, adjustments",
  SM8: "Children of SM1 or SM6, adjustments",
  SM9: "U.S. Armed Forces personnel, service (12 years) by 10/91, adjustments",
  SN1: "Retired NATO-6 civilian employees, new arrivals",
  SN2: "Spouses of SN1 of SN6, new arrivals",
  SN3: "Certain unmarried sons/daughters of SN1 or SN6, new arrivals",
  SN4: "Certain surviving spouses of deceased NATO-6 civilian employees, new arrivals",
  SN6: "Retired NATO-6 civilian employees, adjustments",
  SN7: "Spouses of SN1 of SN6, adjustments",
  SN8: "Certain unmarried sons/daughters of SN1 or SN6, adjustments",
  SN9: "Certain surviving spouses of deceased NATO-6 civilian employees, adjustments",
  SQ1: "Certain Iraqis and Afghans employed by U.S. Government, new arrivals",
  SQ2: "Spouses of SQ1 or SQ6, new arrivals",
  SQ3: "Children of SQ1 or SQ6, new arrivals",
  SQ6: "Certain Iraqis and Afghans employed by U.S. Government, adjustments",
  SQ7: "Spouses of SQ1 or SQ6, adjustments",
  SQ8: "Children of SQ1 or SQ6, adjustments",
  SR1: "Religious workers, new arrivals",
  SR2: "Spouses of SR1 or SR6, new arrivals",
  SR3: "Children of SR1 or SR6, new arrivals",
  SR6: "Religious workers, adjustments",
  SR7: "Spouses of SR1 or SR6, adjustments",
  SR8: "Children of SR1 or SR6, adjustments",
  ST0: "Adjustment of T4 nonimmigrant",
  ST6: "Adjustment of T1 nonimmigrant",
  ST7: "Adjustment of T2 nonimmigrant",
  ST8: "Adjustment of T3 nonimmigrant",
  ST9: "Adjustment of T5 nonimmigrant",
  SU0: "Adjustment of U4 nonimmigrant",
  SU2: "Spouses of SU6, new arrivals",
  SU3: "Children of SU6, new arrivals",
  SU5: "Parents of SU6, new arrivals",
  SU6: "Adjustment of U1 nonimmigrant",
  SU7: "Adjustment of U2 nonimmigrant",
  SU8: "Adjustment of U3 nonimmigrant",
  SU9: "Adjustment of U5 nonimmigrant",
  SY6: "Syrian asylees",
  SY7: "Spouses of SY6",
  SY8: "Children of SY6",
  T51: "Employment creation, targeted area, new arrivals, conditional",
  T52: "Spouses of T51 or T56, new arrivals, conditional",
  T53: "Children of T51 or T56, new arrivals, conditional",
  T56: "Employment creation, targeted area, adjustments, conditional",
  T57: "Spouses of T51 or T56, adjustments, conditional",
  T58: "Children of T51 or T56, adjustments, conditional",
  W16: "Entered without inspection before 1/1/82",
  W26: "Entered as nonimmigrant and overstayed visa before 1/1/82",
  W36: "Blanket enforced voluntary departure (EVD) group",
  W46: "Late amnesty applicants (Immigration Reform and Control Act)",
  XA3: "Children born subsequent to issuance of parent's non-quota visa, new arrivals",
  XB3: "Presumed lawfully admitted for permanent residence",
  XE3: "Children born subsequent to issuance of parent's employment-based preference visa, new arrivals",
  XF3: "Children born subsequent to issuance of parent's family-sponsored preference visa, new arrivals",
  XN3: "Children born subsequent to issuance of parent's visa other, new arrivals",
  XR3: "Children born subsequent to issuance of parent's immediate relative of U.S. citizen visa, new arrivals",
  Y64: "Refugees in the United States prior to July 1, 1953, adjustments",
  Z03: "Entered 7/1/24-6/28/40, Section 249, P.L. 89-236, adjustments",
  Z11: "Preference or non-preference immigrants (other than crewmen)",
  Z13: "Sec. 244, P.L. 89-236, subject to 4,000 annual limit",
  Z14: "Battered spouses or children (Violence Against Women Act), P.L. 103-322 of 1994, subject to 4,000 annual limit",
  Z15: "Salvadoran, Guatemalan and former Soviet bloc country nationals (NACARA Section 203, P.L. 105-100 of 1997)",
  Z33: "Entered before 7/1/24, Section 249, P.L. 89-236, adjustments",
  Z43: "Private bill, adjustments",
  Z56: "Crewmen who entered on or before June 30, 1964 and are immediate relatives of U.S. citizens or special immigrants",
  Z57: "Crewmen who entered on or before June 30, 1964 and are preference or non-preference immigrants",
  Z66: "Entered 6/29/40-1/1/72, Section 249, P.L. 89-236, adjustments",
  Z83: "Foreign government official who is immediate relative of U.S. citizen or special immigrant"
};